import { styled } from '@mui/material';

import { ReactNode } from 'react';

import { Typography, Box } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

import { WhereToStart } from '../WhereToStart';
import { CreateAChallengeCard } from '../CreateAChallengeCard';
import { CreateAReviewCard } from '../CreateAReviewCard';

const StyledBox = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  whiteSpace: 'pre-wrap',
  flex: 1,
  padding: `${theme.spacing(4)} ${theme.spacing(3)}`,
  gap: theme.spacing(4),
}));

const StyledHeader = styled(Typography)({
  fontSize: 18,
});

const Cards = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  gap: theme.spacing(2),
  width: '100%',
}));

export type StartPageProps = {
  mode: 'authorized' | 'guest';
  bottom?: ReactNode;
};

export const StartPage = ({ mode, bottom }: StartPageProps) => {
  const { t } = useI18n();

  return (
    <StyledBox>
      <StyledHeader variant="header">{t('shared:home_slogan')}</StyledHeader>
      <Cards>
        <CreateAChallengeCard mode={mode} />
        <CreateAReviewCard mode={mode} />
      </Cards>
      <WhereToStart title="shared:where_to_start.subtitle" />
      {bottom}
    </StyledBox>
  );
};
